import { render, staticRenderFns } from "./ExternalEmvTapDetails.vue?vue&type=template&id=08c051d6&"
import script from "./ExternalEmvTapDetails.vue?vue&type=script&lang=js&"
export * from "./ExternalEmvTapDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports